import { ApiUtils } from "../helpers/api_utils";
import { ERROR_MESSAGES, UI_CONSTANTS } from "../helpers/constants";
import { DateUtils } from "../helpers/data_utils";
import { VedomItem, BusMapData } from "../types/app.types";
import { dataApi } from "./api";


export class VedomService {
  static async fetchVedomList(date: Date): Promise<VedomItem[]> {
    if (!DateUtils.isValidDate(date)) {
      throw new Error(ERROR_MESSAGES.NO_DATE_SELECTED);
    }

    const formattedDate = DateUtils.formatForBackend(date);

    try {
      const response = await dataApi.getVedomList({
        date: formattedDate,
        withpass: UI_CONSTANTS.WITHPASS_VALUE
      });

      const items = ApiUtils.normalizeVedomResponse(response);

      if (items.length === 0) {
        throw new Error(ERROR_MESSAGES.NO_ROUTES_FOUND);
      }

      return items;
    } catch (error) {
      const errorMessage = ApiUtils.extractErrorMessage(error, ERROR_MESSAGES.FETCH_ROUTES_ERROR);
      throw new Error(errorMessage);
    }
  }

  static async fetchBusMapData(vedomId: string, date: Date): Promise<BusMapData> {
    if (!DateUtils.isValidDate(date)) {
      throw new Error(ERROR_MESSAGES.NO_BUS_MAP_DATE);
    }

    const formattedDate = DateUtils.formatForBackend(date);

    try {
      const data = await dataApi.getVedomData(vedomId, formattedDate);

      if (!data) {
        throw new Error(ERROR_MESSAGES.NO_SERVER_DATA);
      }

      return data;
    } catch (error) {
      const errorMessage = ApiUtils.extractErrorMessage(error, ERROR_MESSAGES.FETCH_BUS_MAP_ERROR);
      throw new Error(errorMessage);
    }
  }
}